export const REPORT_INFO_TYPES = {
  patient: 'patient',
  doctor: 'doctor'
};

export const REPORT_LANGUAGES = [
  {
    key: 'en',
    label: 'English'
  },
  {
    key: 'de',
    label: 'Deutsch'
  }
  // {
  //   key: 'ru',
  //   label: 'Русский'
  // }
];

const REPORT_STATUS_DRAFT = '1';
const REPORT_STATUS_SENT = '2';
const REPORT_STATUS_NEW = '3';

export const REPORT_STATUSES = {
  draft: REPORT_STATUS_DRAFT,
  sent: REPORT_STATUS_SENT,
  new: REPORT_STATUS_NEW
};

export const REPORT_STATUS_VALUES = {
  [REPORT_STATUS_DRAFT]: 'draft',
  [REPORT_STATUS_SENT]: 'sent',
  [REPORT_STATUS_NEW]: 'new'
};

export const REPORT_TYPES = {
  personal: 1,
  medicus: 2
};
